import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';

/**
 * Subscription Report data — GET /admin/analytics/stat/getSubscriptionReport.
 *
 * Returns the whole report in one object: KPIs source (`cube`, `prices`,
 * `fshare`), lifecycle strip (`life`, `recent`), revenue strip (`revlife`,
 * `recentR`), per-month cash collected (`collected` — money actually received in
 * each month whatever the member's status is now, as opposed to the cube's
 * monthly run rate), 13-month `months`, 14-point `weekly`, and one filtered + paginated
 * page of subscriber lifecycles (`subs` + `subsTotal`/`page`/`pages`). The
 * subscriber-table filters travel as query params so filtering/paging happen
 * server-side; the aggregate blocks are stable across those calls.
 */
export const getSubscriptionReport = async (params = {}) => {
  const { q, plan, status, gender, from, to, page, limit } = params;
  const qp = new URLSearchParams();
  if (q) qp.set('q', q);
  if (plan && plan !== 'all') qp.set('plan', plan);
  if (status && status !== 'all') qp.set('status', status);
  if (gender && gender !== 'all') qp.set('gender', gender);
  if (from) qp.set('from', from);
  if (to) qp.set('to', to);
  if (page) qp.set('page', page);
  if (limit) qp.set('limit', limit);
  const query = qp.toString();

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/getSubscriptionReport${query ? `?${query}` : ''}`,
    isAbort: false,
  });
  if (!res) return null;
  if (res.status >= 200 && res.status < 300 && res.data) return res.data.data;
  throw new Error(`Unexpected response code: ${res.status}`);
};
